export const LAYER_ID = 'road_vectors';
export const roadLayers: any = [
  {
    id: LAYER_ID,
    type: 'line',
    source: 'vector-hm',
    'source-layer': 'roads',
    filter: [
      'any',
      ['in', 'pmap:kind', 'major_road', 'medium_road', 'minor_road'],
    ],
    layout: {
      'line-join': 'round',
      'line-cap': 'round',
    },
    paint: {
      'line-opacity': 0.18,
      'line-color': [
        'interpolate',
        ['exponential', 1.6],
        ['zoom'],
        11,
        '#EBEBEB',
        16,
        '#FFFFFF',
      ],
      'line-width': [
        'interpolate',
        ['exponential', 1.6],
        ['zoom'],
        11,
        0,
        12.5,
        0.5,
        15,
        2,
        18,
        11,
      ],
    },
  },
  {
    id: 'roads_labels_major',
    type: 'symbol',
    source: 'vector-hm',
    'source-layer': 'roads',
    filter: [
      'any',
      ['in', 'pmap:kind', 'highway', 'major_road', 'medium_road'],
    ],
    layout: {
      'symbol-sort-key': ['get', 'pmap:min_zoom'],
      'symbol-placement': 'line',
      'text-font': ['Noto Sans Medium'],
      'text-field': ['get', 'name'],
      'text-size': 12,
      'text-letter-spacing': 0.05,
    },
    paint: {
      'text-color': '#FFFFFF',
      'text-halo-color': '#292929',
      'text-halo-width': 1.5,
    },
  },
  {
    id: 'roads_labels_minor',
    type: 'symbol',
    source: 'vector-hm',
    'source-layer': 'roads',
    filter: ['any', ['in', 'pmap:kind', 'minor_road', 'other', 'path']],
    layout: {
      'symbol-sort-key': ['get', 'pmap:min_zoom'],
      'symbol-placement': 'line',
      'text-font': ['Noto Sans Medium'],
      'text-field': ['get', 'name'],
      'text-size': 12,
      'text-letter-spacing': 0.05,
    },
    paint: {
      'text-color': '#FFFFFF',
      'text-halo-color': '#292929',
      'text-halo-width': 1,
    },
  },
];
